import React from 'react';
import { Box, Grid, IconButton, InputAdornment, Paper, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import './login.form.scss';
import { object, string } from 'yup';
import { AuthDto } from '../../../services/dtos/auth.dto';
import InputForm from '../../commun/input-form';
import { Login, Visibility, VisibilityOff } from '@mui/icons-material';
import CustomButton from '../../commun/custom-button';
import { Link } from 'react-router-dom';
import theme from '../../../theme';
import logoRegie from '../../../assets/img/LogoRegie.png';

/**
 * Composant de type Form pour la connexion
 * @param props props
 * @constructor
 */
export default function LoginForm(props: Readonly<{ handlerSubmit: (e: AuthDto) => Promise<void>; loading: boolean }>) {
    // etat de la visibilité du mot de passe
    const [showPassword, setShowPassword] = React.useState(false);

    // mise à jour de la visibilité du mot de passe
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    // Définition des règles de validation
    const validationSchema = object({
        login: string().required("L'e-mail est obligatoire"),
        password: string().required('Le mot de passe est obligatoire'),
    });

    const initValues = {
        login: '',
        password: '',
    };

    // Création du formulaire
    return (
        <Box className="box-login">
            <Link to="/" className="login-brand" aria-label="Accueil">
                <img className="login-brand-logo" src={logoRegie} alt="Logo SDDEA" />
            </Link>

            <Grid container className="grid-login" spacing={2}>
                <Grid item xs={0} sm={4}></Grid>
                <Grid item xs={12} sm={4}>
                    {/*// Encapsulation dans un Container*/}
                    <Paper className="paper-login">
                        <Typography variant="h2">Connexion</Typography>
                        {/*Formulaire*/}
                        <Formik
                            initialValues={initValues}
                            onSubmit={props.handlerSubmit}
                            validationSchema={validationSchema}
                        >
                            <Form>
                                {/*Champ texte Identifiant*/}
                                <InputForm id="login" name="login" label="E-mail" />
                                {/*Champ texte Mot de passe*/}
                                <InputForm
                                    id="password"
                                    name="password"
                                    label="Mot de passe"
                                    type={showPassword ? 'text' : 'password'}
                                    autoComplete="on"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    data-testid="eye-password"
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                        <CustomButton
                                            label={'Connexion'}
                                            type="submit"
                                            variant="contained"
                                            testId="submit"
                                            disabled={props.loading}
                                            element={<Login sx={{ marginLeft: '10px' }} />}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                        <Typography variant="body1">
                                            <Link
                                                data-testid={'forgot-password'}
                                                className="url-text"
                                                to={'/reinitialisation-mot-de-passe'}
                                                style={{ color: theme.palette.blue.main, fontSize: '0.9em' }}
                                            >
                                                Mot de passe oublié&nbsp;
                                            </Link>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Form>
                        </Formik>
                    </Paper>
                </Grid>
                <Grid item xs={0} sm={4}></Grid>
            </Grid>
        </Box>
    );
}
